/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

import {
  Portlet,
  PortletHeader,
  PortletLabel,
  PortletContent,
} from 'components';

// Material components
import {
  Button,
  Grid2,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  IconButton,
  TextField,
  OutlinedInput,
} from '@mui/material';

import { makeStyles } from '@mui/styles';

import * as action from 'js/actions/userActions';
import { showRoles } from 'js/actions/roleActions';

// Component styles
import styles from './styles';
import { showAllCharge } from 'js/actions/chargeActions';
import { showAllMeters } from 'js/actions/meterActions';
import { showAllGroups } from 'js/actions/groupActions';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { Delete } from '@mui/icons-material';
const useStyles = makeStyles(styles);

export default function FormUser() {
  const intl = useIntl();
  const classes = useStyles();
  const { handleSubmit, register } = useForm();
  const dispatch = useDispatch();
  const { corpId } = useParams();
  const [user, setUser] = useState([]);
  const user_id = user?.id;
  const roles = useSelector((state) => state.roles.roles);
  const [data, setData] = useState([]);

  const [role, setRole] = useState(user.role_name ? user.role_name : '');

  const meters = useSelector((state) => state.meters.meters);
  const groups = useSelector((state) => state.groups.groups);
  const charges = useSelector((state) => state.charges.charges);

  const [meter, setMeter] = useState(null);
  const [group, setGroup] = useState({
    group_id: null,
    group: 'Todas las Mediciones',
  });
  const [charge, setCharge] = useState({
    charge_id: null,
    charge: 'Todas las Mediciones',
  });

  let data1 = [];

  const handleDelete = (id) => {
    setState((prevState) => ({
      ...prevState,
      data: prevState.data.filter((item) => item.id !== id),
    }));
  };

  const [state, setState] = useState({
    data: [],
    columns: [
      {
        headerName: 'Action',
        field: '',
        renderCell: (params) => {
          return (
            <IconButton onClick={() => handleDelete(params.row.id)}>
              <Delete />
            </IconButton>
          );
        },
      },
      {
        headerName: intl.formatMessage({
          id: 'app.users.usersList.corpusers.editUser.grid.colMeasure',
        }),
        field: 'meter',
        flex: 1,
      },
      {
        headerName: intl.formatMessage({
          id: 'app.users.usersList.corpusers.editUser.grid.colGroup',
        }),
        field: 'group',
        flex: 1,
      },
      {
        headerName: intl.formatMessage({
          id: 'app.users.usersList.corpusers.editUser.grid.colCarga',
        }),
        field: 'charge',
        flex: 1,
      },
    ],
  });

  const setTable = () => {
    let obj = {
      corporative_id: corpId,
      meter_id: meter.id,
      meter: meter.name,
      group_id: group.id,
      group: group.name,
      charge_id: charge.id,
      charge: charge.name,
      user_id: user_id,
      id: state.data.length + 1,
    };

    setState({
      ...state,
      data: [...state.data, obj],
    });

    data1 = [...state.data, obj];

    setMeter(null);
    setGroup({ group_id: '0', group: 'Todas las Mediciones' });
    setCharge({ group_id: '0', group: 'Todas las Mediciones' });
  };

  useEffect(() => {
    dispatch(showAllMeters(corpId));
  }, [corpId]);

  useEffect(() => {
    dispatch(showRoles());
  }, []);

  const handleChangeMeter = (event) => {
    setMeter(event.target.value);
    dispatch(showAllGroups(corpId, event.target.value.id));
  };

  const handleChangeGroup = (event) => {
    setGroup(event.target.value);
    dispatch(showAllCharge(event.target.value.id));
  };

  const handleChangeCharge = (event) => {
    setCharge(event.target.value);
  };

  const handleChange = (event) => {
    setRole(event.target.value);
  };

  const onSubmit = (user) => {
    if (user.rfc) {
      let msgError = '<pre>';
      let error = false;
      if (!user.razon_social) {
        msgError = intl.formatMessage({
          id: 'app.users.usersList.corpusers.editUser.socReason.msgError',
        });
        error = true;
      }

      if (!user.cfdi) {
        msgError += intl.formatMessage({
          id: 'app.users.usersList.corpusers.editUser.cfdi.msgError',
        });
        error = true;
      }

      if (!user.payment_type) {
        msgError += intl.formatMessage({
          id: 'app.users.usersList.corpusers.editUser.payType.msgError',
        });
        error = true;
      }

      if (!user.payment_method) {
        msgError += intl.formatMessage({
          id: 'app.users.usersList.corpusers.editUser.payMethod.msgError',
        });
        error = true;
      }

      msgError += '</pre>';

      if (error) {
        Swal.fire({
          headerName: intl.formatMessage({
            id: 'app.users.usersList.corpusers.editUser.saveError.headerName',
          }),
          html: msgError,
          icon: 'error',
        });

        return;
      }
    }

    dispatch(action.signUp(user, corpId, state.data));
  };

  return (
    <DashboardLayout headerName="Edición de Usuario">
      <div className={classes.root}>
        <Portlet>
          <PortletHeader>
            <PortletLabel
              title={intl.formatMessage({
                id: 'app.myaccount.editUser.title',
              })}
            />
          </PortletHeader>
          <PortletContent noPadding={true}>
            <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
              <Grid2 container={true} spacing={4}>
                <Grid2 size={{ lg: 6, md: 6, xl: 6, xs: 12 }}>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      // value={user.firstname}
                      defaultValue={user.firstname}
                      {...register('firstname')}
                      label={intl.formatMessage({
                        id: 'app.users.usersList.corpusers.editUser.firstNameLbl',
                      })}
                      name="firstname"
                      required
                      variant="outlined"
                    />
                    <TextField
                      className={classes.textField}
                      defaultValue={user.lastname}
                      {...register('lastname')}
                      label={intl.formatMessage({
                        id: 'app.users.usersList.corpusers.editUser.lastNameLbl',
                      })}
                      name="lastname"
                      required
                      variant="outlined"
                    />
                    <TextField
                      className={classes.textField}
                      defaultValue={user.email}
                      {...register('email')}
                      label={intl.formatMessage({
                        id: 'app.users.usersList.corpusers.editUser.emailLbl',
                      })}
                      name="email"
                      required
                      variant="outlined"
                    />
                    <TextField
                      className={classes.textField}
                      defaultValue={user.password}
                      {...register('password')}
                      helperText={intl.formatMessage({
                        id: 'app.users.usersList.corpusers.editUser.passwordRules',
                      })}
                      label={intl.formatMessage({
                        id: 'app.users.usersList.corpusers.editUser.passwordLbl',
                      })}
                      name="password"
                      type="password"
                      variant="outlined"
                    />

                    <TextField
                      className={classes.textField}
                      defaultValue={user.tel}
                      {...register('tel')}
                      label={intl.formatMessage({
                        id: 'app.users.usersList.corpusers.editUser.phoneNumberLbl',
                      })}
                      name="tel"
                      required
                      variant="outlined"
                    />
                    <TextField
                      className={classes.textField}
                      defaultValue={user.cel}
                      {...register('cel')}
                      label={intl.formatMessage({
                        id: 'app.users.usersList.corpusers.editUser.cellPhoneLbl',
                      })}
                      name="cel"
                      required
                      variant="outlined"
                    />
                    <FormControl className={classes.textField} required>
                      <InputLabel id="demo-simple-select-label">
                        {intl.formatMessage({
                          id: 'app.users.usersList.corpusers.editUser.rolLbl',
                        })}
                      </InputLabel>
                      <Select
                        {...register('role')}
                        labelId="demo-simple-select-disabled-label"
                        name="role"
                        onChange={handleChange}
                        defaultValue={role}
                      >
                        {roles.map((role) => (
                          <MenuItem value={role.id} key={role.id}>
                            {role.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </Grid2>
              </Grid2>

              <Grid2>
                <form style={{ marginBottom: '10px', marginTop: '20px' }}>
                  <Grid2 container={true} spacing={2}>
                    <Grid2 size={{ lg: 12, xs: 12 }}>
                      <FormControl className={classes.textField} required>
                        <InputLabel id="demo-simple-select-label">
                          {intl.formatMessage({
                            id: 'app.users.usersList.corpusers.editUser.configUserAccess.meterLbl',
                          })}
                        </InputLabel>
                        <Select
                          {...register('meter')}
                          labelId="demo-simple-select-disabled-label"
                          name="meter"
                          onChange={handleChangeMeter}
                          value={meter}
                          input={
                            <OutlinedInput
                              label={intl.formatMessage({
                                id: 'app.users.usersList.corpusers.editUser.configUserAccess.meterLbl',
                              })}
                            />
                          }
                        >
                          {meters.map((meter) => (
                            <MenuItem value={meter} key={meter.id}>
                              {meter.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid2>
                    <Grid2 size={6}>
                      <FormControl className={classes.textField}>
                        <InputLabel id="demo-simple-select-label">
                          {intl.formatMessage({
                            id: 'app.users.usersList.corpusers.editUser.configUserAccess.groupLbl',
                          })}
                        </InputLabel>
                        <Select
                          {...register('group')}
                          labelId="demo-simple-select-disabled-label"
                          name="group"
                          onChange={handleChangeGroup}
                          value={group}
                          input={
                            <OutlinedInput
                              label={intl.formatMessage({
                                id: 'app.users.usersList.corpusers.editUser.configUserAccess.groupLbl',
                              })}
                            />
                          }
                        >
                          {groups.map((group) => (
                            <MenuItem value={group} key={group.id}>
                              {group.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid2>
                    <Grid2 size={6}>
                      <FormControl className={classes.textField}>
                        <InputLabel id="demo-simple-select-label">
                          {intl.formatMessage({
                            id: 'app.users.usersList.corpusers.editUser.configUserAccess.chargeLbl',
                          })}
                        </InputLabel>
                        <Select
                          {...register('charge')}
                          labelId="demo-simple-select-disabled-label"
                          name="charge"
                          onChange={handleChangeCharge}
                          value={charge}
                          input={
                            <OutlinedInput
                              label={intl.formatMessage({
                                id: 'app.users.usersList.corpusers.editUser.configUserAccess.chargeLbl',
                              })}
                            />
                          }
                        >
                          {charges.map((charge) => (
                            <MenuItem value={charge} key={charge.id}>
                              {charge.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid2>
                    <Grid2 size={12}>
                      <Button
                        className={classes.signUpButton}
                        color="secondary"
                        onClick={setTable}
                        size="large"
                        variant="outlined"
                      >
                        {intl.formatMessage({
                          id: 'app.users.usersList.corpusers.editUser.configUserAccess.addToListBtn',
                        })}
                      </Button>
                    </Grid2>
                  </Grid2>
                </form>
                <Box mt={3} height={400}>
                  <DataGrid
                    columns={state.columns}
                    rows={state.data}
                    // Disable row selection
                    rowSelection={false}
                    getRowId={(row) => row.id}
                    initialState={{
                      pagination: {
                        paginationModel: {
                          pageSize: 5, // Tamaño de la página
                        },
                      },
                    }}
                    // slots={{ toolbar: QuickSearchToolbar }} // Usa el componente QuickSearchToolbar para la barra de búsqueda
                    sx={{
                      paddingBottom: '1rem',
                      borderRadius: '0.5rem',
                      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
                      backgroundColor: 'background.paper', // Color de fondo de la tabla
                      border: '1px solid #ccc',
                      borderColor: '#ccc',
                      '& .MuiDataGrid-root': {
                        border: 'none', // Eliminar borde de la tabla
                      },
                      '& .MuiDataGrid-cell': {
                        borderBottom: '1px solid rgba(224, 224, 224, 1)', // Borde inferior de la celda
                        maxHeight: '60px', // Altura máxima de la celda
                      },
                      '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior del encabezado de columna
                      },
                      '& .MuiDataGrid-row': {
                        borderBottom: '1px solid rgb(199, 199, 199)', // Borde inferior de la fila
                        maxHeight: '60px', // Altura máxima de la fila
                      },
                    }}
                  />
                </Box>
                {/* <MaterialTable
                  columns={state.columns}
                  data={state.data}
                  editable={{
                    onRowDelete: (oldData) =>
                      new Promise((resolve) => {
                        setTimeout(() => {
                          resolve();
                          const data = [...state.data];
                          data.splice(data.indexOf(oldData), 1);
                          setState({ ...state, data });
                        }, 600);
                      }),
                  }}
                  options={{ toolbar: false }}
                /> */}
              </Grid2>

              <Button
                className={classes.signUpButton}
                color="secondary"
                size="large"
                type="submit"
                variant="contained"
                sx={{ mt: 3 }}
              >
                {intl.formatMessage({
                  id: 'app.users.usersList.corpusers.editUser.configUserAccess.registerBtn',
                })}
              </Button>
            </form>
          </PortletContent>
        </Portlet>
      </div>
    </DashboardLayout>
  );
}
